import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = ({ selectedTransactions, onBulkAction }) => {
  const [showBulkMenu, setShowBulkMenu] = useState(false);
  const navigate = useNavigate();

  const bulkActions = [
    { id: 'export', label: 'Export Selected', icon: 'Download', description: 'Export transaction data to CSV' },
    { id: 'archive', label: 'Archive Selected', icon: 'Archive', description: 'Move to archived transactions' },
    { id: 'request-signatures', label: 'Request Signatures', icon: 'PenTool', description: 'Send signature requests for selected' },
    { id: 'generate-reports', label: 'Generate Reports', icon: 'FileText', description: 'Create progress reports' },
    { id: 'notify-stakeholders', label: 'Notify Stakeholders', icon: 'Bell', description: 'Send status updates' }
  ];

  const handleNewTransaction = () => {
    navigate('/transaction-details/new');
  };

  const handleBulkAction = (actionId) => {
    onBulkAction(actionId, selectedTransactions);
    setShowBulkMenu(false);
  };

  const handleImportTransactions = () => {
    // Trigger file input for CSV import
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.csv,.xlsx';
    input.onchange = (e) => {
      const file = e?.target?.files?.[0];
      if (file) {
        console.log('Importing file:', file?.name);
        // Handle file import logic
      }
    };
    input?.click();
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-soft mb-6">
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between space-y-4 lg:space-y-0">
        {/* Primary Actions */}
        <div className="flex flex-wrap items-center gap-3">
          <Button
            variant="default"
            onClick={handleNewTransaction}
            iconName="Plus"
            iconPosition="left"
            className="bg-primary hover:bg-primary/90"
          >
            New Transaction
          </Button>

          <Button
            variant="outline"
            onClick={handleImportTransactions}
            iconName="Upload"
            iconPosition="left"
          >
            Import Transactions
          </Button>

          <Button
            variant="ghost"
            onClick={() => navigate('/reports-analytics')}
            iconName="BarChart3"
            iconPosition="left"
          >
            View Analytics
          </Button>
        </div>

        {/* Bulk Actions */}
        <div className="flex items-center space-x-3">
          {selectedTransactions?.length > 0 && (
            <div className="flex items-center space-x-2">
              <span className="text-sm text-muted-foreground">
                {selectedTransactions?.length} selected
              </span>
              <div className="relative">
                <Button
                  variant="outline"
                  onClick={() => setShowBulkMenu(!showBulkMenu)}
                  iconName="MoreVertical"
                  iconPosition="right"
                >
                  Bulk Actions
                </Button>

                {showBulkMenu && (
                  <div className="absolute right-0 top-12 w-64 bg-popover border border-border rounded-lg shadow-elevated z-50">
                    <div className="p-2">
                      {bulkActions?.map((action) => (
                        <button
                          key={action?.id}
                          onClick={() => handleBulkAction(action?.id)}
                          className="w-full flex items-start space-x-3 p-3 text-left hover:bg-muted rounded-md transition-smooth"
                        >
                          <Icon name={action?.icon} size={16} className="mt-0.5 text-muted-foreground" />
                          <div>
                            <p className="text-sm font-medium text-foreground">{action?.label}</p>
                            <p className="text-xs text-muted-foreground">{action?.description}</p>
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Quick Stats */}
          <div className="hidden xl:flex items-center space-x-6 pl-6 border-l border-border">
            <div className="text-center">
              <p className="text-lg font-bold text-success">12</p>
              <p className="text-xs text-muted-foreground">Ready</p>
            </div>
            <div className="text-center">
              <p className="text-lg font-bold text-warning">8</p>
              <p className="text-xs text-muted-foreground">In Progress</p>
            </div>
            <div className="text-center">
              <p className="text-lg font-bold text-error">3</p>
              <p className="text-xs text-muted-foreground">Blocked</p>
            </div>
          </div>
        </div>
      </div>
      {/* Quick Filters */}
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-sm text-muted-foreground">Quick filters:</span>
          <Button variant="ghost" size="sm" className="text-xs">
            <Icon name="Clock" size={12} className="mr-1" />
            Due Today (2)
          </Button>
          <Button variant="ghost" size="sm" className="text-xs">
            <Icon name="AlertTriangle" size={12} className="mr-1" />
            Overdue (1)
          </Button>
          <Button variant="ghost" size="sm" className="text-xs">
            <Icon name="PenTool" size={12} className="mr-1" />
            Awaiting Signature (5)
          </Button>
          <Button variant="ghost" size="sm" className="text-xs">
            <Icon name="Shield" size={12} className="mr-1" />
            Blockchain Verified (18)
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;